import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'react-redux';
import Global from '../../../../../store/global-selectors';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import messages from '../../messages';
import styles from './styles.module.less';

const ConfirmSendTestModal = ({ isSending, onConfirm }) => {
  const user = useSelector(Global.selectUserCurrentUserInfo);
  const stores = useSelector(Global.selectSellerActiveStores);
  const [selectedStore, setSelectedStore] = useState();
  const [storeError, setStoreError] = useState(false);

  const onConfirmClick = () => {
    if (!selectedStore) {
      setStoreError(true);
      return;
    }
    onConfirm(selectedStore.storeGuid);
  };

  const onStoreSelect = (store) => {
    if (storeError) {
      setStoreError(false);
    }
    setSelectedStore(store);
  };

  return (
    <Modal size='small'>
      <ModalHeader>
        <FormattedMessage {...messages.sendTestConfirmationTitle} />
      </ModalHeader>
      <ModalBody className={styles.body}>
        {isSending && <LoadingIndicator className={styles['loading-indicator']} />}
        {!isSending && (
          <>
            <div className={styles.line}>
              <div>
                <FormattedMessage {...messages.storeSelectionLabel} />
              </div>
              <DropdownMenu>
                <DropdownMenuToggler hasError={storeError} theme='white'>
                  {selectedStore?.name || <FormattedMessage {...messages.storeDropdownDefault} />}
                </DropdownMenuToggler>
                {stores.map((store) => {
                  return (
                    <DropdownMenuItem key={store.storeGuid} onClick={() => onStoreSelect(store)}>
                      {store.name}
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenu>
            </div>
            <div className={styles.line}>
              <div>
                <FormattedMessage {...messages.sendTo} />
              </div>
              <div className={styles.target}>{user.email}</div>
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <ModalFooterCancelButton />
        <Button onClick={onConfirmClick} testId='confirm-delete-btn' theme='primary'>
          <FormattedMessage {...messages.sendTestEmail} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ConfirmSendTestModal.propTypes = {
  isSending: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmSendTestModal;
